(function () {
  'use strict';
  if (window.bcjUpcartPackSavingsLoaded) return;
  window.bcjUpcartPackSavingsLoaded = true;

  // Display only. Shopify's cart remains the authority for every charged amount.
  var handles = new Set(['elk-mesquite-meat-sticks', 'jalapeno-cheese-meat-stick',
    'teriyaki-meat-stick', 'hickory-venison-meat-sticks', 'peppered-beef-jerky',
    'jalapeno-honey-meat-sticks', 'original-meat-stick', 'habanero-heat-jerky',
    'sweet-heat-jerky', 'honey-bbq-jerky', 'teriyaki-pork-jerky', 'hickory-bbq-jerky',
    'original-beef-jerky', 'beefcake-jalapeno-cheese-beef-bites']);
  var standardPlans = new Set(['9632678195', '9629368627']);
  var tileSelector = '.upcart-public-component-product-tile';
  var priceSelector = '.upcart-public-component-product-tile__product-pricing';
  var compareSelector = '[data-upcart-chunk="cart-item-compare-at-price"], .upcart-public-component-product-tile__price-compare-at';
  var savingsSelector = '[data-upcart-chunk="cart-item-savings"], .upcart-public-component-product-tile__savings';
  var root, observer, cart, models = new Map(), productCache = new Map();
  var generation = 0, refreshTimer, paintPending = false, subscriptions = new Set();
  var shippingReady = false, shippingPending = false;

  function planId(line) {
    var allocation = line && line.selling_plan_allocation;
    return allocation && allocation.selling_plan ? String(allocation.selling_plan.id) : '';
  }

  function scoped(line) {
    return !!line && handles.has(line.handle) && !line.has_components &&
      !(line.properties && line.properties._dynamicBoxId) &&
      (!planId(line) || standardPlans.has(planId(line)));
  }

  function packCount(variant) {
    var value = variant && (variant.option1 || variant.title) || '';
    var match = String(value).match(/^(\d+)\s*(?:pack|bag|stick)?\b/i);
    return match ? Number(match[1]) : 0;
  }

  function calculateLine(line, product, promotion) {
    if (!scoped(line) || !product || !Array.isArray(product.variants)) return null;
    var variant = product.variants.find(function (v) { return String(v.id) === String(line.variant_id); });
    var count = packCount(variant), quantity = Number(line.quantity), charged = line.final_line_price;
    if (!variant || !count || !Number.isSafeInteger(quantity) || quantity < 1 ||
      !Number.isSafeInteger(charged) || charged < 0 || !Number.isSafeInteger(variant.price)) return null;
    if (planId(line) && !(variant.selling_plan_allocations || []).some(function (a) {
      return String(a.selling_plan_id) === planId(line);
    })) return null;
    var baseline = product.variants.filter(function (v) {
      return v.available && packCount(v) > 0 && Number.isSafeInteger(v.price) && v.price > 0;
    }).sort(function (a, b) { return packCount(a) - packCount(b); })[0];
    var reference = variant.price, caption = 'vs one-time price';
    // A discounted one-time line keeps its campaign/base-price comparison.
    var campaign = !planId(line) && promotion && promotion.active && promotion.price < variant.price;
    if (!campaign && baseline && count > packCount(baseline)) {
      reference = Math.round(baseline.price * count / packCount(baseline));
      caption = packCount(baseline) === 1 ? 'vs buying single bags' :
        'vs buying the same quantity in ' + packCount(baseline) + '-packs';
    }
    reference *= quantity;
    if (!Number.isSafeInteger(reference)) return null;
    return { reference: reference, saved: Math.max(0, reference - charged), caption: caption, quantity: quantity };
  }

  function activeCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '';
  }

  function shippingStatus(next, country) {
    if (!next || next.requires_shipping !== true || !Array.isArray(next.items) || !next.items.length ||
      !Number.isSafeInteger(next.total_price) || next.total_price < 0) return null;
    if (!next.items.some(function (line) { return line && line.requires_shipping === true; })) return null;
    var generic = { text: 'Shipping calculated at checkout.' };
    if (next.currency !== 'USD' || (country && country !== 'US') || next.items.some(function (line) {
      return !line || line.requires_shipping !== true || !Number.isSafeInteger(line.quantity) || line.quantity < 1;
    })) return generic;
    var recurring = 0, unsupported = false;
    next.items.forEach(function (line) {
      var id = planId(line);
      if ((line.selling_plan_allocation && !id) ||
        (line.properties && line.properties._dynamicBoxId) ||
        (id && !scoped(line))) unsupported = true;
      if (id) recurring += 1;
    });
    if (unsupported) return generic;
    if (recurring === next.items.length) return { text: 'Free U.S. shipping on subscription deliveries.' };
    if (recurring) return { text: 'Subscription items ship free in the U.S.; other shipping calculated at checkout.' };
    if (next.total_price >= 14999) return { text: 'Free U.S. shipping on this order.' };
    return { remaining: 14999 - next.total_price };
  }

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: cart.currency
    }).format(cents / 100);
  }

  function route(path) {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return base.replace(/\/?$/, '/') + path;
  }

  function readJSON(path) {
    return fetch(route(path), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart comparison unavailable'); return response.json(); });
  }

  function productFor(handle, currency) {
    var key = route('') + ':' + currency + ':' + handle;
    var cached = productCache.get(key);
    if (!cached || Date.now() - cached.time > 30000) {
      cached = { time: Date.now(), promise: readJSON('products/' + encodeURIComponent(handle) + '.js') };
      productCache.set(key, cached);
      cached.promise.catch(function () { if (productCache.get(key) === cached) productCache.delete(key); });
    }
    return cached.promise;
  }

  function identity(tile) {
    var link = tile.querySelector('.upcart-public-component-product-tile__title-link, a[href*="/products/"]');
    if (!link) return null;
    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      var handle = url.pathname.match(/\/products\/([^/]+)/);
      return handle ? { handle: decodeURIComponent(handle[1]), variant: url.searchParams.get('variant'), plan: url.searchParams.get('selling_plan') || '' } : null;
    } catch (_) { return null; }
  }

  function matchingLine(tile) {
    var id = identity(tile);
    if (!id || !cart) return null;
    var matches = cart.items.filter(function (line) {
      return line.handle === id.handle && String(line.variant_id) === id.variant && planId(line) === id.plan;
    });
    // The same variant/plan can have distinct properties or discounts: never guess a line.
    return matches.length === 1 ? matches[0] : null;
  }

  function scopedIdentity(tile) {
    var id = identity(tile);
    return id && handles.has(id.handle) && (!id.plan || standardPlans.has(id.plan));
  }

  function hide(node) {
    if (!node) return;
    node.setAttribute('data-bcj-pack-hidden', '');
    var label = node.previousElementSibling;
    if (label && label.classList.contains('upcart-internal__visually-hidden')) label.setAttribute('data-bcj-pack-hidden', '');
  }

  function restore(container) {
    container.querySelectorAll('[data-bcj-pack-hidden]').forEach(function (node) { node.removeAttribute('data-bcj-pack-hidden'); });
    container.querySelectorAll('[data-bcj-pack-comparison]').forEach(function (node) { node.remove(); });
  }

  function comparison(container, text, caption) {
    var display = container.querySelector('[data-bcj-pack-comparison]');
    if (!display) {
      display = document.createElement('div');
      display.setAttribute('data-bcj-pack-comparison', '');
      display.appendChild(document.createElement('strong'));
      display.appendChild(document.createElement('small'));
      container.appendChild(display);
    }
    if (display.firstElementChild.textContent !== text) display.firstElementChild.textContent = text;
    if (display.lastElementChild.textContent !== caption) display.lastElementChild.textContent = caption;
  }

  function paintShipping(currencyMatches) {
    var display = root.querySelector('[data-bcj-cart-shipping]');
    var status = shippingReady && !shippingPending && currencyMatches ?
      shippingStatus(cart, window.Shopify && window.Shopify.country) : null;
    var header = root.querySelector('.upcart-public-header');
    if (!status || !header) { if (display) display.remove(); return; }
    var text = status.text || 'Add ' + money(status.remaining) + ' for free U.S. shipping.';
    if (!display) {
      display = document.createElement('p');
      display.setAttribute('data-bcj-cart-shipping', '');
      display.setAttribute('role', 'status');
      display.setAttribute('aria-live', 'polite');
      display.setAttribute('aria-atomic', 'true');
    }
    if (display.textContent !== text) display.textContent = text;
    if (display.previousElementSibling !== header) header.insertAdjacentElement('afterend', display);
  }

  function paintTaxNote(currencyMatches) {
    var display = root.querySelector('[data-bcj-cart-tax-note]');
    var checkout = root.querySelector('.upcart-checkout-button-container');
    var ready = shippingReady && !shippingPending && currencyMatches && cart.items.length &&
      typeof cart.requires_shipping === 'boolean';
    if (!ready || !checkout) { if (display) display.remove(); return; }
    var text = cart.requires_shipping ? 'Shipping and taxes calculated at checkout.' : 'Taxes calculated at checkout.';
    if (!display) {
      display = document.createElement('p');
      display.setAttribute('data-bcj-cart-tax-note', '');
    }
    if (display.textContent !== text) display.textContent = text;
    if (display.nextElementSibling !== checkout) checkout.insertAdjacentElement('beforebegin', display);
  }

  function markShippingPending(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target || !target.closest('.upcart-public-component-product-tile__quantity-minus, ' +
      '.upcart-public-component-product-tile__quantity-plus, .upcart-public-component-product-tile__remove-button, ' +
      '.upcart-public-component-upsell-tile button, input[aria-label="Product quantity"]')) return;
    shippingPending = true;
    shippingReady = false;
    paintShipping(false);
    paintTaxNote(false);
  }

  function paint() {
    if (!root) return;
    var currencyMatches = cart && (!activeCurrency() || activeCurrency() === cart.currency);
    paintShipping(currencyMatches);
    paintTaxNote(currencyMatches);
    var hasScoped = cart ? cart.items.some(scoped) : Array.from(root.querySelectorAll(tileSelector)).some(scopedIdentity);
    var rendered = new Set();
    root.querySelectorAll(tileSelector).forEach(function (tile) {
      var line = matchingLine(tile), row = tile.querySelector(priceSelector);
      if (!row) return;
      if ((line && !scoped(line)) || (!line && !scopedIdentity(tile))) { restore(row); return; }
      row.querySelectorAll(compareSelector + ', ' + savingsSelector).forEach(hide);
      var quantityInput = tile.querySelector('input[aria-label="Product quantity"]');
      var quantityMatches = !quantityInput || (line && Number(quantityInput.value) === Number(line.quantity));
      var model = currencyMatches && line && quantityMatches ? models.get(line.key) : null;
      if (model) rendered.add(line.key);
      if (!model || !model.saved) {
        row.querySelectorAll('[data-bcj-pack-comparison]').forEach(function (node) { node.remove(); });
        return;
      }
      comparison(row, 'Save ' + money(model.saved) + (model.quantity > 1 ? ' on ' + model.quantity + ' packs' : ' total'),
        model.caption + ' (' + money(model.reference) + ').');
    });
    // Footer savings are optional in UpCart. Preserve discount-code chips and actual totals.
    root.querySelectorAll('.upcart-public-cart-summary').forEach(function (summary) {
      var amount = summary.querySelector('.upcart-public-cart-summary__total-discount');
      if (!hasScoped || !amount) { restore(summary); return; }
      hide(amount);
      hide(summary.querySelector('.upcart-public-cart-summary__discount-label'));
      var complete = currencyMatches && cart.items.length && cart.items.every(function (line) { return scoped(line) && models.has(line.key) && rendered.has(line.key); });
      var saved = complete ? Math.max(0, cart.items.reduce(function (sum, line) { return sum + models.get(line.key).reference; }, 0) - cart.total_price) : 0;
      if (saved > 0) comparison(summary, 'Total savings ' + money(saved), 'Compared with the references shown above.');
      else summary.querySelectorAll('[data-bcj-pack-comparison]').forEach(function (node) { node.remove(); });
    });
  }

  function schedulePaint() {
    if (paintPending) return;
    paintPending = true;
    window.requestAnimationFrame(function () { paintPending = false; paint(); });
  }

  function refresh() {
    var request = ++generation, currency = activeCurrency();
    shippingReady = false;
    schedulePaint();
    readJSON('cart.js').then(function (next) {
      if (request !== generation || currency !== activeCurrency() || !Array.isArray(next.items) || !next.currency) return;
      if (!Number.isSafeInteger(next.total_price) || next.total_price < 0) throw new Error('Missing cart total');
      cart = next; shippingReady = true; models = new Map(); schedulePaint();
      return Promise.all(next.items.filter(scoped).map(function (line) {
        return productFor(line.handle, next.currency).then(function (product) {
          if (request !== generation || currency !== activeCurrency()) return;
          var variant = product.variants && product.variants.find(function (v) { return String(v.id) === String(line.variant_id); });
          var promotion = variant && !planId(line) && window.BCJPromotion && window.BCJPromotion.details({
            handle: line.handle, variantId: variant.id, price: variant.price, sellingPlanId: ''
          });
          var model = calculateLine(line, product, promotion);
          if (model) models.set(line.key, model);
        }).catch(function () { /* Hide unsupported comparisons; keep the native charge visible. */ });
      })).then(function () { if (request === generation) schedulePaint(); });
    }).catch(function () {
      if (request !== generation) return;
      shippingReady = false;
      models = new Map(); schedulePaint();
    });
  }

  function scheduleRefresh() {
    // Invalidate pending responses immediately, before the debounced request starts.
    generation += 1;
    shippingReady = false;
    models = new Map();
    schedulePaint();
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 40);
  }

  function connect() {
    ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened'].forEach(function (name) {
      if (!subscriptions.has(name) && typeof window[name] === 'function') {
        subscriptions.add(name);
        window[name](function () { shippingPending = false; connect(); scheduleRefresh(); });
      }
    });
    var host = document.getElementById('upCart'), nextRoot = host && host.shadowRoot;
    if (!nextRoot || nextRoot === root) return;
    if (observer) observer.disconnect();
    root = nextRoot;
    var style = document.createElement('style');
    style.textContent = '[data-bcj-pack-hidden]{display:none!important}' +
      '[data-bcj-pack-comparison]{flex-basis:100%;margin-top:4px;line-height:1.35;white-space:normal;overflow-wrap:anywhere}' +
      '[data-bcj-pack-comparison] strong{font-size:13px;color:#b7440c}' +
      '[data-bcj-pack-comparison] small{display:block;font-size:12px;color:#5f5c57}' +
      '[data-bcj-cart-shipping]{box-sizing:border-box;flex-shrink:0;margin:0;padding:8px 16px;' +
      'max-width:100%;background:#fff4ed;color:#63280e;font-size:13px;line-height:1.4;overflow-wrap:anywhere}' +
      '[data-bcj-cart-tax-note]{margin:0 0 8px;max-width:100%;color:#5f5c57;font-size:13px;line-height:1.4;text-align:center;overflow-wrap:anywhere}';
    root.appendChild(style);
    observer = new MutationObserver(function (changes) {
      if (changes.some(function (change) {
        var target = change.target.nodeType === 1 ? change.target : change.target.parentElement;
        return !target || !target.closest('[data-bcj-pack-comparison], [data-bcj-cart-shipping], [data-bcj-cart-tax-note]');
      })) schedulePaint();
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    root.addEventListener('click', markShippingPending, true);
    root.addEventListener('input', markShippingPending, true);
    root.addEventListener('change', scheduleRefresh);
    scheduleRefresh();
  }

  var attempts = 0;
  var discovery = window.setInterval(function () { connect(); if (++attempts >= 30 || (root && subscriptions.size === 3)) window.clearInterval(discovery); }, 1000);
  window.addEventListener('pageshow', function () { connect(); scheduleRefresh(); });
  window.addEventListener('bcj:promotion:change', scheduleRefresh);
  document.addEventListener('cart:updated', scheduleRefresh);
  // Reconnect if the app loads after the bounded startup timer or replaces its host.
  new MutationObserver(connect).observe(document.documentElement, { childList: true, subtree: true });
  connect();
})();
